if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    setTimeout(() => {
        const observer = new MutationObserver((MutationList) => {
            console.log(MutationList)
            for (let item of MutationList) {
                if (item.target.classList.contains('cart-bubble__text-count')) {
                    setTimeout(() => {
                        BSS_B2B.observer.cartSubject.notifyObserver('CartMutate', 'CartPriceMutate');
                        BSS_B2B.observer.cartSubject.listenCartCheckout();
                    }, 1000)

                }
                if (item.target.classList.contains('predictive-search-results__inner')) {
                   handleCartDrawerFooterMutation();
                }            
            }
        })
        observer.observe(document.body, {
            childList: true,
            subtree: true
        })
    }, 300)
    setTimeout(() => {
        handleCartDrawerFooterMutation();
        BSS_B2B.observer?.cartSubject?.notifyObserver('CartMutate', 'CartPriceMutate');
    }, 3000)

    async function handleCartDrawerFooterMutation() {
        if (BSS_B2B) {
            const res = await BSS_B2B.storage.productStorage.load();
            if (res) {
                if (res.notExistProductIds?.length || res.productIds?.length || res.variantIds?.size) {
                    BSS_B2B.observer.productSubject.notifyObserver('LazyProduct', 'LoadedLazyProduct', {
                    ...res
                    });
                }
            }
        }
    }
}